import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "./Client.css";
import { clearAuthSession } from "../authSession";
import { useStore } from "../store";

export default function ClientLayout() {
  const navigate = useNavigate();
  const clearUser = useStore((s) => s.clearUser);

  function logout() {
    clearAuthSession();
    clearUser();
    navigate("/login");
  }

  return (
    <div className="client-shell">
      <aside className="client-sidebar">
        <div className="client-brand">EVIACORE</div>

        <nav className="client-nav">
          <NavLink to="/app/projects" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
            Mes Projets
          </NavLink>

          <NavLink to="/app/quotes" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
            Mes Devis
          </NavLink>

          {/* <NavLink to="/app/order-tracking" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
            Suivi commande
          </NavLink> */}

          <NavLink to="/app/settings" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>
            Mon Profil
          </NavLink>
        </nav>

        <button className="client-logout" onClick={logout}>
          Déconnexion
        </button>
      </aside>

      <main className="client-content">
        <Outlet />
      </main>
    </div>
  );
}
